/*
 * @Author: panweikang
 * @Date: 2025-04-19 10:31:43
 * @LastEditTime: 2025-04-20 11:40:10
 * @Description: 
 */

import React, { Component, useEffect, useState, useMemo } from "react";
import './index.scss'
import { connect } from 'react-redux';
import MTabBar from '../../../../../components/MTabBar';
import { Icon } from 'antd-mobile'
import zixunPng from '../../../../../images/mine/zixun.png'
import MFooter from "../../../../../components/MFooter";
import MHead from "../../../../../components/MHead";
import { CACHE_ACCESS_TOKEN, CACHE_SESSION_USER } from "../../../../../constants/Profile";
import HttpUtils from "../../../../../utils/HttpUtils";
import { ArticleDetailsApi } from "../../../WebService";
import { DateTimeFormat } from "../../../../../utils/DateUtil";

const ArticleDetails = ({ dispatch, router }) => {


  useEffect(() => {
    ArticleDetailsHandle(router.params.id)
  }, [])


  const [initContent, setInitContent] = useState(null)


  const ArticleDetailsHandle = (id) => {
    HttpUtils.get(`${ArticleDetailsApi}?id=${id}`, (res) => {
      setInitContent(res.data)
    })
  }

  return (
    <>
      {
        <div className="tabbarBottom ArticleDetails">
          <MHead isBack={false} />
          {
            initContent && <div className="ArticleDetailsContent">
              {/* <div className="ArticleDetailsTitle">
                <h5> {initContent.title} </h5>
                <h6>发布时间 {DateTimeFormat.dateToHyphenString(initContent.updateTime)}</h6>
              </div> */}
              <div
                className="ArticleDetailsContentBody"
                style={{ padding: 0 }}
                dangerouslySetInnerHTML={{ __html: initContent.body }}></div>
            </div>
          }

        </div>
      }
      <MTabBar router={router} index={3} />
    </>
  );
};


function mapStateToProps(store) {
  return {};
}


export default connect(mapStateToProps)(ArticleDetails);
